import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import IconButton from '@mui/material/IconButton'
import MenuIcon from '@mui/icons-material/Menu'
import Collapse from '@mui/material/Collapse'

import logo from 'resources/images/logo.webp'
import cn from 'utils/cn'
import LanguageComponent from 'components/LanguageComponent'

export default function Header() {
    const { t } = useTranslation()
    // 默认值，避免 SSR-CSR 不一致
    const [isMobile, setIsMobile] = useState(false)
    const navigate = useNavigate()
    const handleMobile = () => {
        setIsMobile(!isMobile)
    }

    const menuItems = [
        { name: 'home.home', path: '/' },
        { name: 'home.aboutUs', path: '/about-us' },
        { name: 'home.ourServices', path: '/our-services' },
        { name: 'home.ourStrength', path: '/our-strength' },
        { name: 'home.contactUs', path: '/contact-us' },
    ]

    return (
        <div className='fixed top-0 left-0 right-0  bg-white w-full z-40 shadow-[0_0.5rem_1rem_rgba(0,0,0,0.15)]shadow-2xl'>
            <div className=' px-5 flex items-center justify-between md:px-8 lg:px-10'>
                <div onClick={() => navigate('/')} className='w-[180px] h-fit cursor-pointer py-4'>
                    <img src={logo} alt='sinoasiabnr logo' className='w-full h-auto object-contain' loading='lazy' />
                </div>
                <div className='flex lg:hidden'>
                    <IconButton onClick={handleMobile} aria-label='menu'>
                        <MenuIcon />
                    </IconButton>
                </div>
                <div className='items-center hidden lg:flex'>
                    {menuItems.map((item, index) => (
                        <a
                            key={`nav-${index}`}
                            href={item.path}
                            onClick={(e) => {
                                e.preventDefault()
                                navigate(item.path)
                            }}
                            className={cn(
                                'text-[#333333] text-base font-medium hover:underline whitespace-nowrap',
                                index === menuItems.length - 1 ? 'mr-2' : 'mr-5',
                            )}
                        >
                            {t(item.name)}
                        </a>
                    ))}

                    <LanguageComponent />
                </div>
            </div>
            <Collapse className='absolute top-[83.8px] left-0 right-0 z-10 lg:hidden' in={isMobile}>
                <div className='bg-white flex pl-5 pr-7 justify-between w-full md:px-10'>
                    <div className='flex flex-col py-4'>
                        {menuItems.map((item, index) => (
                            <a
                                key={`nav-${index}`}
                                href={item.path}
                                className={cn(
                                    'text-[#333333] py-1 w-full text-base font-medium hover:underline whitespace-nowrap',
                                    index === menuItems.length - 1 ? 'mr-2' : 'mr-5',
                                )}
                            >
                                {t(item.name)}
                            </a>
                        ))}
                    </div>
                    <LanguageComponent />
                </div>
            </Collapse>
        </div>
    )
}
